<div class="float-filter-input">
  @if ((selectionType$$ | async) === 'single') {
  <glxy-form-field class="filter-float-selector">
    <input
      matInput
      type="number"
      placeholder="{{'GALAXY.FILTER.CHIP.VALUE_PLACEHOLDER' | translate}}"
      [formControl]="valueControl"
    />
  </glxy-form-field>
  } @else {
  <glxy-form-field class="filter-float-range-selector">
    <input
      matInput
      type="number"
      placeholder="{{'GALAXY.FILTER.CHIP.START_VALUE_PLACEHOLDER' | translate}}"
      [formControl]="valueControl"
    />
  </glxy-form-field>
  <span class="range-splitter">–</span>
  <glxy-form-field class="filter-float-range-selector">
    <input
      matInput
      type="number"
      placeholder="{{'GALAXY.FILTER.CHIP.END_VALUE_PLACEHOLDER' | translate}}"
      [formControl]="endValueControl"
    />
  </glxy-form-field>
  }
</div>
